import React from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "../i18n.jsx";

function Row({ items }) {
  return (
    <div className="flex shrink-0 items-center">
      {items.map((it) => (
        <span
          key={it}
          className="flex items-center gap-2.5 whitespace-nowrap px-6 text-[11px] font-semibold uppercase tracking-[0.22em] text-paper/45"
        >
          <Sparkles className="h-3.5 w-3.5 text-acid" />
          {it}
        </span>
      ))}
    </div>
  );
}

export default function MarqueeRibbon() {
  const { content } = useLang();
  const items = content.marquee || [];
  return (
    <div className="marquee relative overflow-hidden border-y border-paper/10 bg-ink2/40 py-3">
      <div className="animate-marquee flex w-max">
        <Row items={items} />
        <Row items={items} />
      </div>
    </div>
  );
}
